import { useNavigate } from 'react-router-dom';
import { API_URL } from '../services/api';

const useGoToApp = (portalUser) => {
  const navigate = useNavigate();

  const goToApp = async () => {
    try {
      if (!sessionStorage.getItem('demoData') && portalUser?.tenant_id) {
        const portalToken = localStorage.getItem('portalToken') || localStorage.getItem('token');
        const resp = await fetch(`${API_URL}/api/demo/credentials/${portalUser.tenant_id}`, {
          headers: portalToken ? { 'Authorization': `Bearer ${portalToken}` } : {},
        });
        if (resp.ok) {
          const data = await resp.json();
          const expiresAt = data.expires_at ? new Date(data.expires_at) : null;
          sessionStorage.setItem('demoData', JSON.stringify({
            facility_name: data.facility_name || 'Demo Facility',
            expires_in_hours: expiresAt ? Math.max(1, Math.ceil((expiresAt - Date.now()) / 3600000)) : 24,
            credentials: (data.credentials || []).map((c) => ({
              role: c.role,
              display_name: c.display_name,
              username: c.username,
              password: c.password,
            })),
          }));
        }
      }
    } catch (e) {
      // Fall through to the login form; the demo box will simply be absent
    }
    navigate('/login');
  };

  return goToApp;
};

export default useGoToApp;
